export default __webpack_public_path__ + "static/media/Energy-Saving-Simulator.15a58487.png";